import { Link } from '~/shared/components/Link';
import { ScrollToTop } from '~/shared/components/ScrollToTop';
import SearchField from '~/shared/components/SearchField';
import { ModuleContainer } from '../../shared/ModuleContainer';
import Brands from './Brands';
import CategoryFilter from './CategoryFilter';
import { Alphabet, AlphabetContainer, AlphabetItem, Content, Filter, Wrapper } from './styled';
import useBrandFiltering from './useBrandFiltering';

export default function M45BrandOverview() {
    const {
        isError,
        existingLettersByBrand,
        query,
        allLetters,
        setQuery,
        setCategory,
        categories,
        category,
        isLoadingBrands,
        isLoadingCategories,
    } = useBrandFiltering();

    return (
        <ModuleContainer hasGutter>
            <AlphabetContainer>
                <Alphabet>
                    {allLetters.map((letter, index) =>
                        existingLettersByBrand.find(
                            (existingLetter) => existingLetter[0] === letter,
                        ) ? (
                            <AlphabetItem key={letter}>
                                <Link href={`#${letter}`} fullWidth multipleElements>
                                    {letter}
                                </Link>
                            </AlphabetItem>
                        ) : (
                            <AlphabetItem key={index} missingLetter>
                                {letter}
                            </AlphabetItem>
                        ),
                    )}
                </Alphabet>
            </AlphabetContainer>

            <Wrapper>
                <Filter>
                    <SearchField
                        type="text"
                        value={query}
                        setInputValue={setQuery}
                        placeholder="Søg brands"
                    />
                    {categories?.categories ? (
                        <CategoryFilter
                            categories={categories?.categories}
                            activeCategory={category}
                            setBrandCategory={setCategory}
                            isLoading={isLoadingCategories}
                        />
                    ) : null}
                </Filter>
                <Content>
                    <Brands
                        isError={isError}
                        existingLettersByBrand={existingLettersByBrand}
                        isLoading={isLoadingBrands}
                    />
                </Content>
            </Wrapper>

            <ScrollToTop />
        </ModuleContainer>
    );
}
